export default __webpack_public_path__ + "static/media/icon1.2553510d.jfif";